export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/oidc.99114d05.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};